<template>
    <v-container fluid>
        <v-btn
            :loading="providerGroupsWithInfo === null"
            @click="newProviderGroup"
            bottom
            class="mb-10"
            color="secondary darken-1"
            fab
            fixed
            right
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-row
            align="center"
            no-gutters
        >
            <v-col
                cols="12"
                justify="center"
                lg="4"
                sm="6"
            >
                <v-subheader>
                    <h2>ProviderGroups ({{totalMatches}})</h2>
                </v-subheader>
            </v-col>
            <v-col
                cols="12"
                lg="4"
                sm="6"
            >
                <v-text-field
                    @click:clear="setSearch('')"
                    @input="setSearch"
                    clearable
                    label="Search"
                    prepend-icon="mdi-magnify"
                    single-line
                />
            </v-col>
            <v-col
                class="text-right"
                cols="12"
                lg="4"
                sm="6"
            >
                <!--<v-btn
                    @click="showFilters = !showFilters"
                    color="secondary darken-1"
                    icon
                >
                    <v-icon>mdi-tune</v-icon>
                </v-btn>-->
            </v-col>
        </v-row>
        <v-container class="pb-10">
            <v-row
                justify="center"
                v-if="providerGroupsWithInfo === null"
            >
                <v-col
                    :key="i"
                    cols="12"
                    lg="6"
                    v-for="i in 6"
                >
                    <v-skeleton-loader
                        elevation="4"
                        type="card"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row
                justify="center"
                v-else
            >
                <v-col
                    :key="providerGroupWithInfo.entity.id"
                    cols="12"
                    lg="6"
                    v-for="providerGroupWithInfo in providerGroupsWithInfo"
                >
                    <!--@click="loadProviderGroupForm(providerGroupWithInfo.entity)"-->
                    <v-card
                    @click="loadProviderGroupForm(providerGroupWithInfo.entity)"
                        class="entity-card fill-height"
                        elevation="4"
                        style="overflow:hidden"
                    >
                        <v-card-title>
                            <h5>{{providerGroupWithInfo.entity.name}}</h5>
                        </v-card-title>
                        <!--<v-card-text class="pt-0">Customers: {{providerGroupWithInfo.info.customerCount}}</v-card-text>-->
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog
            persistent
            v-model="providerGroupFormVisible"
            width="500px"
        >
            <ProviderGroupForm
                :key="providerGroupFormKey"
                :provider-group-in="providerGroupFormProviderGroup"
                @close="closeProviderGroupForm"
                @deleted="deleteProviderGroup"
                @saved="updateProviderGroup"
            />
        </v-dialog>


        <v-pagination
            :length="pagesCount"
            @input="paginationDebounce(500, true)"
            class="pagination-bar base-background"
            total-visible="7"
            v-model="pageNo"
            v-show="pagesCount > 1"
        ></v-pagination>
    </v-container>
</template>

<script>
//import ProviderGroup from "../models/ProviderGroup.model";
import uuid4 from "../helpers/uuid4";
import ProviderGroup from "../models/ProviderGroup.model";
import ProviderGroupForm from "../components/forms/ProviderGroupForm"

export default {
    name: "ProviderGroups",
    props: ["status"],
    data: function() {
        return {
            //main data
            providerGroupsWithInfo: null,
            //pagination
            pageNo: 1,
            pageSize: 6,
            pagesCount: 0,
            totalMatches: null,
            searchString: "",
            orderBy: "",
            sortOrder: null,
            paginationTimeout: null,
            requestId: uuid4(),

            //form
            providerGroupFormVisible: false,
            providerGroupFormKey: 0,
            providerGroupFormProviderGroup: new ProviderGroup()
        };
    },
    mounted: function() {
        this.getProviderGroups();
    },
    //activated: function(){//when keep a live is brought back up},
    components: {
        ProviderGroupForm
        //
    },
    methods: {
        getProviderGroups() {
            var requestId = (this.requestId = uuid4());
            this.$store
                .dispatch("providerGroups/get", {
                    id: null,
                    urlParameters: {
                        pageNo: this.pageNo,
                        pageSize: this.pageSize,
                        searchString: this.searchString,
                        orderBy: this.orderBy,
                        sortOrder: this.sortOrder
                    },
                    requestId: requestId
                })
                .then(providerGroupsResponse => {
                    if (this.requestId == providerGroupsResponse.requestId) {
                        this.providerGroupsWithInfo = providerGroupsResponse.data.page;
                        this.totalMatches = providerGroupsResponse.data.total;
                        this.pageSize = providerGroupsResponse.data.pageSize;
                        this.pageNo = providerGroupsResponse.data.pageNumber;
                        this.pagesCount = Math.ceil(
                            providerGroupsResponse.data.total / this.pageSize
                        );
                    }
                });
        },
        paginationDebounce(debounceTime, isPaging) {
            if (!isPaging) {
                this.pageNo = 1;
                this.pagesCount = 0;
            }
            if (this.providerGroupsWithInfo !== null) this.providerGroupsWithInfo = null;
            clearTimeout(this.paginationTimeout);
            this.paginationTimeout = setTimeout(
                this.getProviderGroups,
                debounceTime
            );
        },
        setSearch(value) {
            this.searchString = value;
            this.paginationDebounce(1000);
        },

        //FORM METHODS---------------------------------
        newProviderGroup() {
            var providerGroup = new ProviderGroup();
            providerGroup.id = 0;
            this.loadProviderGroupForm(providerGroup);
        },
        loadProviderGroupForm(providerGroup) {
            this.providerGroupFormProviderGroup = new ProviderGroup().set(providerGroup);
            this.providerGroupFormKey = providerGroup.id;
            this.providerGroupFormVisible = true;
        },
        closeProviderGroupForm() {
            this.providerGroupFormVisible = false;
            this.providerGroupFormProviderGroup = new ProviderGroup();
            this.providerGroupFormKey = null;
        },
        updateProviderGroup() {
            this.paginationDebounce(0);
        },
        deleteProviderGroup() {
            this.paginationDebounce(0);
        }
    }
};
</script>

<style lang="stylus" scoped>
.entity-card
    /* background: linear-gradient(45deg, rgba(127,127,127,0.1), transparent,rgba(127,127,127,0.1)) */
    .center-content
        background-color: rgba(127, 127, 127, 0.15)

.pagination-bar
    // position: fixed;
    bottom: 0
    margin: auto
    left: 0
    right: 0
    padding-bottom: 0.1rem
    padding-top: 0.1rem
    /*
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border:1px solid rgba(127, 127, 127, 0.2)
    */

.theme--light
    .base-background
        background: #FFFFFF

.theme--dark
    .base-background
        background: #121212
</style>
